import { render } from "./table-row.vue?vue&type=template&id=8ab4aaac&ts=true"
import script from "./table-row.vue?vue&type=script&lang=ts"
export * from "./table-row.vue?vue&type=script&lang=ts"

import "./table-row.vue?vue&type=style&index=0&id=8ab4aaac&lang=css"

import exportComponent from "/working_dir/Loupey.WebApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__